import React, { useContext, useRef, useState } from 'react';
import FilieraContext from '../../../contexts/filieraContext';
import { filiereDataSource } from '../../../datasources/filiereDataSource';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Popup,
  Form,
  Lookup,
  Format,
  Button as GridButton,
  ToolbarItem
} from 'devextreme-react/data-grid';
import { listiniAnimaliDataSource } from '../../../datasources/listiniAnimaliDataSource';
import { dataGridErrorHandling } from '../../../utils/errorHandling';
import Box, {
  Item
} from 'devextreme-react/box';
import { Button, Switch, Toolbar } from 'devextreme-react';
import { Item as FormItem } from 'devextreme-react/form';
import PopupUploadFile, { UploadFilePopupHandle } from '../../../components/popupUploadFile/popupUploadFile';
import PopupListino, { ListinoPopupHandle } from '../../../components/popupListini/popupListini';
import { apiConfiguration } from '../../../apiConfig';
import { ListinoAnimaliDettaglioDTO } from "../../../data";
import { macelliDataSource } from '../../../datasources/macelliDataSource';

type Props = {
  listino?: ListinoAnimaliDettaglioDTO,
  readonly?: boolean
};

export default function ListinoAnimaliPage(params: Props) {
  const { currentFiliera } = useContext(FilieraContext);
  const [ showAll, setShowAll ] = useState <boolean> (false);
  const uploadRef = useRef<UploadFilePopupHandle>(null);
  const listinoRef = useRef<ListinoPopupHandle>(null);
  const gridRef = useRef<DataGrid>(null);
  

  function openUploadFilePopup(e: any) {
    const uploadUrl: string = apiConfiguration.basePath + "/Filiere/" + currentFiliera.Id + "/cliente/" + e.row.data.cliente;

    uploadRef.current?.show(currentFiliera.Id, e.row.data.idListino, e.row.data.idFiliera, uploadUrl);
  }
  
  function refreshGrid() {
    gridRef.current?.instance.refresh();
  }

  function new_click(e: any) {
      listinoRef.current?.new(e.row.data.idFiliera);
  }

  function edit_click(e: any) {
    listinoRef.current?.edit(e.row.data.idListino);
  }

  const styles = {
    alignTitle: {
      marginLeft: "40px",
      marginRight: "40px",
    },
    fixSwitch: {
      width: "unset"
    }
  };

  return (
    <React.Fragment>
      <Box
        direction="row"
        width="100%"
        height={75}
        align="center"
        crossAlign="center">
        <Item ratio={2}>
          <div className="rect" >
          <h2 style={styles.alignTitle}>Listino Animali</h2>
          </div>
        </Item>
      </Box>

      <DataGrid
        className={'dx-card wide-card'}
        dataSource={listiniAnimaliDataSource(currentFiliera.Id, showAll)}
        showBorders={false}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnAutoWidth={true}
        errorRowEnabled={false}
        columnHidingEnabled={true}
        onRowUpdating={function (e) { e.newData = Object.assign({}, e.oldData, e.newData) }}
        onDataErrorOccurred={dataGridErrorHandling}
        onInitNewRow={(e) => {
          e.data.idFiliera = currentFiliera?.Id;
        }}
      >
        <Editing
          mode="popup"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}>
          <Popup title="Animale" showTitle={true} />
          <Form>
          
            <FormItem dataField='idFiliera' visible={false}/>
            <FormItem dataField='idAnagrafe' editorType={'dxSelectBox'} />
            
          </Form>
        </Editing>
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        <FilterRow visible={true} />

        <Column type="buttons" alignment='left'>
          <GridButton name="edit" onClick={edit_click}  />
        </Column>
        <Column dataField={'idListino'} width={90} hidingPriority={1} allowEditing={false} visible={false} showEditorAlways={false} />
        <Column dataField={'idFiliera'} caption='Filiera' >
          <Lookup dataSource={filiereDataSource} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>
        <Column dataField={'idAnagrafe'} caption='Macelli' visible= {false}>
          <Lookup dataSource={macelliDataSource} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>
        <Column dataField={'cliente'} />

        <Toolbar>
          <ToolbarItem location="after">
            <Button
              icon="refresh"
              onClick={refreshGrid}
            />
            <Button
              icon="add"
              onClick={new_click}
              disabled={params.readonly}
            />
          </ToolbarItem>
        </Toolbar>
      </DataGrid>

      <PopupListino ref={listinoRef} listino={params.listino} tipoListino={"Animali"} onChange={refreshGrid } readonly={params.readonly}></PopupListino>
    </React.Fragment>
  )
}

